import IMAGE_ASSETS from "./imageAssets.json";
export const SITE_URL = process.env.REACT_APP_SITE_URL;
if (!SITE_URL) throw new Error("REACT_APP_SITE_URL est requis");
export const SITE_NAME = "OZC IMMO";
export const PHONE = "+33627400405";
export const PHONE_DISPLAY = "+33 6 27 40 04 05";
export const EMAIL = "ozcimmo00@gmail.com";
export const ADDRESS = {
  street: "1 rue de la Montagne",
  postalCode: "68100",
  city: "Mulhouse",
  country: "France",
};
export const HOURS = "Pendant nos horaires de disponibilité";
export const RESPONSE_PROMISE = "Réponse sous 1h pendant nos horaires de disponibilité";
export const SIRET = "940 519 408 00014";
export const LEGAL_NAME = "OZC IMMO";
export const LEGAL_FORM = "Société à responsabilité limitée";
export const REGISTERED_ADDRESS = { street: "35 rue des Vergers", postalCode: "68800", city: "Thann", country: "France" };
export const LEGAL_SOURCE = "https://annuaire-entreprises.data.gouv.fr/entreprise/940519408";
export const FOUNDER = "Ismail Ozcan";
export const FOUNDER_IMG = "/images/ismail-ozcan-fondateur-ozc-immo.webp";

export const SLOGAN = "Votre bien. Notre expertise. Votre tranquillité.";
export const TAGLINE =
  "Sous-location professionnelle, conciergerie et gestion locative premium en Alsace, sur la Côte d'Azur et à Marrakech.";

export const img = (id, w = 1200, h = 800) =>
  `/images/${id.startsWith("portfolio/") ? id : IMAGE_ASSETS[id]}-${w <= 640 ? 640 : w <= 1200 ? 1200 : 1920}.webp`;
export const imageSrcSet = (id) => [640, 1200, 1920].map(w => `${img(id, w)} ${w}w`).join(", ");

export const IMG = {
  hero: "1512917774080-9991f1c4c750",
  villaNight: "portfolio/marrakech-villa-contemporaine",
  interior: "portfolio/mulhouse-salon",
  apartment: "1502005229762-cf1b2da7c5d6",
  marrakech: "1570133435573-fcb96d98f69b",
  nice: "portfolio/cote-azur-villa",
  niceApt: "portfolio/paris-appartement-caractere",
  cannes: "portfolio/cote-azur-jardin",
  croisette: "portfolio/cote-azur-villa",
  saintTropez: "portfolio/cote-azur-jardin",
  antibes: "portfolio/cote-azur-villa",
  strasbourg: "portfolio/strasbourg-appartement",
  petiteFrance: "portfolio/strasbourg-appartement",
  colmar: "portfolio/paris-appartement-caractere",
  mulhouse: "portfolio/mulhouse-duplex",
  loft: "1638454795595-0a0abf68614d",
  saintLouis: "1765767056681-9583b29007cf",
  studio: "1769690399055-6cac5380d470",
  concierge: "1757439402190-99b73ac8e807",
};

export const OG_IMAGE = img(IMG.hero, 1200, 630);

export const DEFAULT_WA_MESSAGE =
  "Bonjour OZC IMMO, je suis propriétaire d'un bien et je souhaite connaître vos solutions de sous-location professionnelle ou de conciergerie.";

export const waMessageForCity = (city) =>
  `Bonjour OZC IMMO, je suis propriétaire d'un bien à ${city} et je souhaite connaître vos solutions de sous-location professionnelle ou de conciergerie.`;

export const waLink = (message = DEFAULT_WA_MESSAGE) =>
  `https://wa.me/${PHONE.replace("+", "")}?text=${encodeURIComponent(message)}`;

export const TRUST_INDICATORS = [
  { value: "15 %", label: "Commission conciergerie", sub: "Du chiffre d'affaires locatif, selon contrat" },
  { value: "A à Z", label: "Gestion complète", sub: "De l'annonce au suivi du logement" },
  { value: "1", label: "Interlocuteur direct", sub: "Ismail Ozcan, fondateur et gérant" },
  { value: "Mensuel", label: "Reporting propriétaire", sub: "Activité, suivi et recommandations" },
];
